export const TEXTS = {
  INPUT_SBBID_ERROR_COMPANY_ALREADY_EXISTS:
    'Такая организация уже существует. Обратитесь за помощью к нашему менеджеру. Возможно, кто-то из ваших коллег уже регистрировался в сервисе.',
  INPUT_SBBID_ERROR_COMPANY_ALREADY_EXISTS_MANAGER: 'Написать менеджеру',
  INPUT_SBBID_ERROR_COMPANY_ALREADY_EXISTS_CLOSE: 'Закрыть',
};
